
// ********* Import CSS ***************** //

import '@styles/main.scss';
import './about.css';

// ********* Add Top Nav & Footer *************** //

import '../nav-header-footer/nav-header-footer.js';
import '../nav-header-footer/nav-header-footer.css';

// ************ Add JS for Email Signup & Error Popup *************** //

import '../nav-header-footer/email-contact-new-classes.js';

// **************************** Loading Spinner ****************************** //

window.addEventListener('load', () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.display = "block";
    setTimeout(() => {
      preloader.style.transition = "opacity 0.2s ease";
      preloader.style.opacity = 0;
      setTimeout(() => preloader.remove(), 200);
    }, 600);
  }
});

// ******************************* Audio Player **************************** //

// const podcastCard5 = document.querySelector(".podcast-card-5")

// progress5 = document.getElementById("progress-bar-5")

// Audio5 = document.getElementById("episode-audio-5")

// AudioSource5 = document.querySelector("episode-audio-5")

// playButton5 = document.getElementById("play-pause-button-5")

// playButtonImg5 = document.getElementById("play-pause-image-5")

// currentTimeShown5 = document.getElementById("current-time-5")

// currentTime5 = podcastCard5.querySelector(".current-time-5")

// endTime5 = podcastCard5.querySelector(".end-time-5")

// window.onload = function() {
   
//   console.log("Podcast page loading");

//   progress1.max = Audio1.duration;
//   let AudioDuration1 = Audio1.duration;
//   let finalMinutes1 = Math.floor(AudioDuration1 / 60);
//   let finalSeconds1 = Math.floor(AudioDuration1 % 60);

//   if(finalSeconds1 < 10) {
//     finalSeconds1 = "0" + finalSeconds1;
//   }

//   endTime1.innerHTML = finalMinutes1+":"+finalSeconds1;

//   currentTime1.innerHTML = "0"+":"+"0"+"0";
// };

// Audio5.addEventListener("loadedmetadata", () => {

//   if (Audio5.readyState >= 2) {

//     progress5.max = Audio5.duration;
  
//    let AudioDuration5 = Audio5.duration;

//    let finalMinutes5 = Math.floor(AudioDuration5 / 60);

//    let finalSeconds5 = Math.floor(AudioDuration5 % 60);
  
//    if(finalSeconds5 < 10) {
//      finalSeconds5 = "0" + finalSeconds5;
//    }

//    currentTime5.innerHTML = "0"+":"+"0"+"0";

//    endTime5.innerHTML = finalMinutes5+":"+finalSeconds5;
//  }
// });



// var playCount5 = 0;

// playButton5.addEventListener("click", () => {

//   const isAudioPaused = podcastCard5.classList.contains("paused");

//   if(isAudioPaused) {
//     pauseAudio5();
//   }
//   else {
//     playAudio5();
//   }

//   playCount5 += 1;

//   if (playCount5 == 1) {
//     countPodcastPlay(5);
//   }
// });


// var currentlyPlaying = 0;

// function playAudio5() {

//   podcastCard5.classList.add("paused");
//   playButtonImg5.src = "https://sav-ym-podcast.s3.us-east-2.amazonaws.com/pause-fill-grey.svg";
  
//   Audio5.play();
//   currentlyPlaying = 5;
  
//   setInterval(() => {
//     progress5.value = Audio5.currentTime;
//   }, 500);
// }

// function pauseAudio5(){
//   podcastCard5.classList.remove("paused");
//   playButtonImg5.src = "https://sav-ym-podcast.s3.us-east-2.amazonaws.com/play-fill-grey.svg";

//   Audio5.pause();
// }

// var episodeNum = null;

// function countPodcastPlay(episodeNum) {

//     episodeNum = episodeNum;

//     console.log("episodeNum: ", episodeNum);

//     var data = {
//         podcast: 'sav-ym-podcast',
//         episodeNum: episodeNum
//     }

//     fetch('https://script.google.com/macros/s/AKfycbwfOdi-eqxOpPDFwJsO-0CSR6QuGuADITbR1lLU7VklD4TNGFz587dzwobSynk32IRqWg/exec', { 
//       redirect: "follow",
//       method: "POST",
//       headers: {
//          "Content-Type": "text/plain;charset=utf-8"
//       },
//       body: JSON.stringify(data)
//     })
//      .then((response) => response.json())
//     .then ((result) =>  { 
//        console.log('data:', result.data);
//            console.log('Submission Result:', result.result);
          
//         })
//     .catch(error => { 
//        console.log('error:', error)
//   });
// }



// progress5.onchange = function(){
//   Audio5.currentTime = progress5.value;
//   console.log("Audio Current Time: ", Audio5.currentTime);
// }

// Audio5.addEventListener("timeupdate", (e)=>{

//   let CurrentTime = Audio5.currentTime;

//   let currentMinutes = Math.floor(CurrentTime / 60);
//   let currentSeconds = Math.floor(CurrentTime % 60);
//   if(currentSeconds < 10){
//     currentSeconds = "0"+currentSeconds;
//   }
//   currentTime5.innerText = currentMinutes+":"+currentSeconds;
// });

// Audio5.addEventListener("ended", (e)=>{

//   let currentMinutes = 0;
//   let currentSeconds = '00';

//   currentTime5.innerText = currentMinutes+":"+currentSeconds;
//   podcastCard5.classList.remove("paused");
//   playButtonImg5.src = "https://sav-ym-podcast.s3.us-east-2.amazonaws.com/play-fill-grey.svg";
//   progress5.value = 0;
//   Audio5.currentTime = progress5.value;
// });
